import { RadioButtonWithLabelGroupWidget, RadioButtonWithLabelOption } from '@tableau/widgets';
import React from 'react';
import { useCallback, useMemo } from 'react';

import { Messages } from '../../../../../codegen/Localize';
import { SiteAvailabilityState } from '../../../../../sites/SitePropertyTypes';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { useFormikContext } from '../../../../FormikWrapperForStubbing';
import { settingsRadioButtonItemHeight } from '../../../../styles/CommonStyles';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForServerAdminProps } from '../../site-settings/ReactSiteSettingsForServerAdmin';

export const AVAILABILITY_FIELD_NAME = 'availability';
export type SiteAvailabilitySectionProps = SiteSettingsForServerAdminProps<never>;

function getButtonsList(): RadioButtonWithLabelOption<string>[] {
  return [
    {
      value: SiteAvailabilityState.ACTIVE,
      label: Messages.activeDetails(),
      testId: 'site-active-radio-button'
    },
    {
      value: SiteAvailabilityState.SUSPENDED,
      label: Messages.suspendedDetails(),
      testId: 'site-suspended-radio-button'
    }
  ];
}

export function SiteAvailabilitySection(props: SiteAvailabilitySectionProps) {
  const formik = useFormikContext<SiteAvailabilitySectionProps>();

  // need to memoize this because at the module level, the Messages class may not be ready yet so we can't use it to
  // initialize labels
  const buttonsList = useMemo(getButtonsList, []);
  const currentIndex = buttonsList.findIndex(button => button.value === formik.values.availability);

  const handleChange = useCallback((value: string) => formik.setFieldValue(AVAILABILITY_FIELD_NAME, value), [formik]);

  return !props.isDefaultSite
    && !props.hideAvailability
    && <SettingsSection title={Messages.availability()}
                        description={Messages.availabilityDetails()}>
      <RadioButtonWithLabelGroupWidget
        className={settingsRadioButtonItemHeight}
        ariaLabel={Messages.availability()}
        name={AVAILABILITY_FIELD_NAME}
        buttonList={buttonsList}
        checkedIndex={currentIndex}
        handleChange={handleChange}
      />
    </SettingsSection>;
}

/**
 * Specs for registering the component in the settings registry
 */
export const SiteAvailabilitySpecs = componentRegistryEntry({
  name: 'SiteAvailabilitySection',
  component: SiteAvailabilitySection,
});
